fragment ChatbotReportDbMetricsFragment on ChatbotReportDbMetrics {
    visitorCount
    conversationCount
    visitorsFilledFormPercent
    topNudges {
        nudgeId
        content
        pageSlugs
        threadCount
        threadIds
    }
}
